<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>KPI考核</el-breadcrumb-item>
            <el-breadcrumb-item>大盘绩效模板管理</el-breadcrumb-item>
            <el-breadcrumb-item>对应关系管理</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-col :span="10">
          <el-row :gutter="2">
            <!-- <el-col :span="4">
                <el-button type="danger" size="small" clearable @click="Refresh" plain>生成大盘绩效</el-button>
            </el-col>
            <el-col :span="4">
                <el-button type="danger" size="small" clearable @click="Refresh" plain>生成季度绩效</el-button>
            </el-col> -->
            <el-col :span="3">
              <el-button type="primary" size="small" @click="Refresh" plain
                >刷新</el-button
              >
            </el-col>
          </el-row>
        </el-col>
        <el-col style="text-align:right;" :span="14">
          <el-button type="primary" size="small" @click="AddTask" plain
            >添加</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table
            :data="BigTemplateList"
            style="width: 100%"
            v-loading="loading"
            size="small"
          >
            <el-table-column prop="Id" label="编号"></el-table-column>
            <el-table-column label="类型">
              <template slot-scope="scope">
                <span>{{
                  scope.row.EType == 0
                    ? "部门"
                    : scope.row.EType == 2
                    ? "个人"
                    : "岗位"
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="MainDeptsName"
              label="部门"
            ></el-table-column>
            <el-table-column prop="DutyName" label="岗位"></el-table-column>
            <el-table-column prop="UserName" label="创建人"></el-table-column>
            <el-table-column
              prop="CreateTime"
              label="添加时间"
            ></el-table-column>
            <el-table-column prop="Remark" label="备注"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button @click="UpdateTemplate(scope.row)" type="text"
                  >编辑</el-button
                >

                <el-popconfirm
                  title="确定删除此条信息吗？"
                  @onConfirm="DeleteTemplate(scope.row)"
                >
                  <el-button type="text" slot="reference" style="color:red;"
                    >删除</el-button
                  >
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row style="text-align:right;">
        <el-col>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
            style="float:right"
          ></el-pagination>
        </el-col>
      </el-row>
      <el-dialog
        width="50%"
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        top="10px"
      >
        <el-row>
          <el-col :span="6">
            <el-container>
              <el-aside style="width:100%;">
                <el-input
                  style="margin-bottom:12px"
                  size="small"
                  placeholder="输入关键字进行过滤"
                  v-model="filterText"
                ></el-input>
                <el-tree
                  class="filter-tree"
                  :data="data"
                  v-loading="loading"
                  :props="defaultProps"
                  node-key="id"
                  @node-click="handleNodeClick"
                  :filter-node-method="filterNode"
                  ref="tree"
                >
                  <span class="custom-tree-node" slot-scope="{ node }">
                    <span style="font-size:14px;height:40px;">{{
                      node.label
                    }}</span>
                  </span>
                </el-tree>
              </el-aside>
            </el-container>
          </el-col>
          <el-col :span="18">
            <el-form :model="TemplaateModel" ref="taskForm">
              <el-form-item
                label="类型"
                :label-width="formLabelWidth"
                size="small"
              >
                <el-select
                  v-model="TemplaateModel.EType"
                  style="float:left;"
                  placeholder="请选择类型"
                  @change="onSelectedKPIType"
                >
                  <el-option value="0" label="部门"></el-option>
                  <el-option value="1" label="岗位"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                size="small"
                label="部门"
                v-show="MainDeptsNameIsShow"
                :label-width="formLabelWidth"
              >
                <el-input
                  v-model="TemplaateModel.MainDeptsName"
                  :disabled="true"
                  placeholder="请选择当前部门"
                ></el-input>
              </el-form-item>
              <el-form-item
                size="small"
                label="岗位"
                v-show="DutyIsShow"
                :label-width="formLabelWidth"
              >
                <el-select
                  v-model="TemplaateModel.DutyId"
                  clearable
                  filterable
                  style="float:left;"
                  placeholder="请选择岗位"
                >
                  <el-option
                    v-for="v in dutyList"
                    :label="v.Duty"
                    :key="v.Id"
                    :value="v.Id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="OperTemplaateModel">保存</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
import {
  BigKPITemplateRelation,
  GetBigKPITemplateRelation,
  BigKPITemplateRelationSave,
  DelBigKPITemplateRelation
} from "../../until/ZeusApiSDK/Logic/KPISettingLogic";
import {
  GetDutysByFrameId,
  GetDutysDetail
} from "../../until/ZeusApiSDK/Logic/StructureLogic";
import {
  GetCurrentUserInfo,
  GetNewGuid
} from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { getUrlKey } from "../../until/ZeusApiSDK/Logic/ImageStr";
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";
import { GetFrameTreeList } from "../../until/ZeusApiSDK/Logic/Frame";
export default {
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  data() {
    return {
      MainDeptsNameIsShow: false, //默认隐藏
      DutyIsShow: false,
      dutyList: [], //当前部门中心下岗位
      kpiId: "",
      filterText: "",
      eType: "",
      BigTemplateList: [],
      pageSizes: [10, 20, 50, 100, 200],
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      loading: true,
      childrenOverdrafts: [],
      dialogVisible: false,
      dialogTitle: "添加信息",
      TemplaateModel: {
        Id: "",
        EType: "",
        MainDeptsID: "",
        MainDeptsName: "",
        DutyId: "",
        DutyName: "",
        kpiTid: "",
        userCode: ""
      },
      currentUser: {},
      formLabelWidth: "120px",
      currentRole: {}, //当前登录用户角色
      data: [], //树状节点
      defaultProps: {
        children: "children",
        label: "label",
        disabled: "type"
      }
    };
  },
  created() {
    this.kpiId = getUrlKey("kpiId");

    this.getCurrentUser();
    this.GetBigTemplateRelationList();

    //获取当前用户角色
    this.getCurrentRole();

    //获取部门树状结构信息
    this.GetFrameTree();
  },
  methods: {
    //获取部门树
    GetFrameTree: async function() {
      //获取部门信息
      await GetFrameTreeList().then(res => {
        this.loading = false;
        this.data = JSON.parse(res);
      });
    },
    //部门树节点点击
    handleNodeClick: function(data) {
      this.TemplaateModel.MainDeptsName = data.label;
      this.TemplaateModel.MainDeptsID = data.Id;
      //获取当前部门中心下岗位
      this.GetDutysByFrameId(this.TemplaateModel.MainDeptsID);
    },
    //获取当前部门中心下岗位
    GetDutysByFrameId: function(MainDeptsID) {
      GetDutysByFrameId(MainDeptsID).then(res => {
        this.dutyList = res.list;
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetBigTemplateRelationList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetBigTemplateRelationList();
    },
    //类型改变事件
    onSelectedKPIType: function(event) {
      this.eType = event;
      if (event == 0) {
        //部门
        this.MainDeptsNameIsShow = true;
        this.DutyIsShow = false;
      } else {
        //岗位
        this.MainDeptsNameIsShow = true;
        this.DutyIsShow = true;
      }
    },
    // Search: function() {
    //   this.pageIndex = 1;
    //   this.GetBigTemplateRelationList();
    // },
    //刷新
    Refresh: function() {
      this.GetBigTemplateRelationList();
    },
    AddTask: function() {
      this.dialogTitle = "添加信息";
      this.dialogVisible = true;
      this.TemplaateModel = {
        Id: "",
        EType: "",
        MainDeptsID: "",
        MainDeptsName: "",
        DutyId: "",
        DutyName: "",
        kpiTid: "",
        userCode: ""
      };
    },
    UpdateTemplate: function(row) {
      this.dialogTitle = "编辑信息";
      this.dialogVisible = true;
      GetBigKPITemplateRelation(row.Id).then(res => {
        if (res.Code == 200) {
          this.TemplaateModel = res.Data;
          this.TemplaateModel.EType =
            this.TemplaateModel.EType == 0 ? "部门" : "岗位";
          if (res.Data.EType == "部门") {
            //部门
            this.MainDeptsNameIsShow = true;
            this.DutyIsShow = false;
          } else {
            //岗位
            this.MainDeptsNameIsShow = true;
            this.DutyIsShow = true;
          }
          //获取当前部门中心下岗位
          this.GetDutysByFrameId(this.TemplaateModel.MainDeptsID);
        } else {
          this.TemplaateModel = {
            Id: "",
            EType: "",
            MainDeptsID: "",
            MainDeptsName: "",
            DutyId: "",
            DutyName: "",
            kpiTid: "",
            userCode: ""
          };
        }
      });
    },
    doTask: function(row) {
      DoTask(row).then(res => {
        var type = "success";
        if (res.Status == 2) {
          type = "warning";
        } else if (res.status == 3) {
          type = "danger";
        }
        this.$message({
          message: res.msg,
          type: type,
          center: true
        });
        this.GetBigTemplateRelationList();
      });
    },
    getCurrentUser: function() {
      this.currentUser = GetCurrentUserInfo();
    },
    //获取当前用户角色
    getCurrentRole: function() {
      var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
      this.currentRole = JSON.parse(Decrypt(currentUserRole));
    },
    DeleteTemplate: function(row) {
      DelBigKPITemplateRelation(this.currentUser.UserCode, row.Id).then(res => {
        if (res.Code == 200) {
          this.$message({
            message: "删除成功",
            type: "success",
            center: true
          });
        } else {
          this.$message({
            message: "删除失败",
            type: "danger",
            center: true
          });
        }
        this.GetBigTemplateRelationList();
      });
    },
    OperTemplaateModel: function() {
      this.$refs["taskForm"].validate(valid => {
        if (valid) {
          if (this.TemplaateModel.Id) {
            //编辑
            // this.TemplaateModel.EType =
            //   this.TemplaateModel.EType === "部门" ? 0 : 1;
            //   this.TemplaateModel.kpiTid=this.kpiId;
            if (this.TemplaateModel.DutyId) {
              GetDutysDetail(this.TemplaateModel.DutyId).then(res => {
                this.TemplaateModel.DutyName = res.Data.ClassName;
                this.TemplaateModel.EType=this.TemplaateModel.EType=='岗位'?1:(this.TemplaateModel.EType=='部门'?0:this.TemplaateModel.EType);
                if( this.TemplaateModel.EType==0){
                    this.TemplaateModel.DutyId='';
                    this.TemplaateModel.DutyName='';
                }
                this.AddBigTemplateRelation(this.TemplaateModel);
              });
            } else {
              this.TemplaateModel.EType=this.TemplaateModel.EType=='岗位'?1:(this.TemplaateModel.EType=='部门'?0:this.TemplaateModel.EType);
              this.TemplaateModel.DutyName = "";
              this.AddBigTemplateRelation(this.TemplaateModel);
            }
          } else {
            //添加
            //根据岗位id获取岗位
            this.TemplaateModel.userCode = this.currentUser.UserCode;
            this.TemplaateModel.kpiTid = this.kpiId;
            this.TemplaateModel.EType = this.eType; //0部门 1岗位
            if (this.TemplaateModel.DutyId) {
              GetDutysDetail(this.TemplaateModel.DutyId).then(res => {
                this.TemplaateModel.DutyName = res.Data.ClassName;
                this.AddBigTemplateRelation(this.TemplaateModel);
              });
            } else {
              this.AddBigTemplateRelation(this.TemplaateModel);
            }
          }
        }
      });
    },
    //添加对应关系
    AddBigTemplateRelation: function(TemplaateModel) {
      BigKPITemplateRelationSave(TemplaateModel).then(result => {
        if (result.Code == 200) {
          this.$message({
            message: "保存成功",
            type: "success",
            center: true
          });
          this.dialogVisible = false;
          this.GetBigTemplateRelationList();
        } else {
          this.$message({
            message: "保存失败",
            type: "danger",
            center: true
          });
        }
      });
    },
    //获取绩效模板列表
    GetBigTemplateRelationList: function() {
      this.loading = true;
      var userinfo = GetCurrentUserInfo();
      BigKPITemplateRelation(this.kpiId, this.pageIndex, this.pageSize).then(
        pageRes => {
          if ((pageRes.Code = 200)) {
            this.BigTemplateList = pageRes.Data.DataList;
            this.totalCount = pageRes.totalCount;
            this.loading = false;
          } else {
            this.BigTemplateList = [];
            this.totalCount = 0;
            this.loading = false;
          }
        }
      );
    }
  }
};
</script>
